import { Checkbox } from '@/shared/components/ui/checkbox';
import { FormField } from './FormField';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { Field } from '@/shared/components/ui/field';

interface FormFieldCheckboxProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  disabled?: boolean;
  'data-testid'?: string;
}

export function FormFieldCheckbox<T extends FieldValues>({
  'data-testid': testId,
  ...props
}: FormFieldCheckboxProps<T>) {
  return (
    <FormField
      {...props}
      render={({ field, invalid, disabled }) => (
        <Field orientation="horizontal">
          <Checkbox
            id={props.name}
            checked={field.value as unknown as boolean}
            onCheckedChange={field.onChange}
            disabled={disabled}
            aria-invalid={invalid}
            data-testid={testId}
          />
        </Field>
      )}
    />
  );
}
